// The homepage keeps only the mobile navigation behavior. The viscosity
// explorer was removed from the experience, so no chart code is shipped here.
const menu = document.querySelector('.menu-toggle');
const nav = menu && document.getElementById(menu.getAttribute('aria-controls'));

if (menu && nav) {
  const closeMenu = () => {
    menu.setAttribute('aria-expanded', 'false');
    nav.hidden = true;
  };

  menu.addEventListener('click', () => {
    const open = menu.getAttribute('aria-expanded') !== 'true';
    menu.setAttribute('aria-expanded', String(open));
    nav.hidden = !open;
  });

  nav.addEventListener('click', event => {
    if (event.target.closest('a')) closeMenu();
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !nav.hidden) {
      closeMenu();
      menu.focus();
    }
  });
}


document.querySelectorAll('[data-product-lightbox]').forEach(button => {
  button.addEventListener('click', () => {
    const dialog = document.querySelector('#product-lightbox');
    if (!dialog) return;
    const image = dialog.querySelector('img');
    image.src = button.dataset.fullImage;
    dialog.classList.remove('is-zoomed');
    dialog.querySelector('.lightbox-zoom').setAttribute('aria-pressed', 'false');
    dialog.querySelector('.lightbox-zoom').textContent = 'Zoom in';
    dialog.querySelector('.lightbox-original').href = button.dataset.fullImage;
    image.alt = button.querySelector('img')?.alt || 'ViscoMotion product image';
    dialog.showModal();
  });
});
document.querySelector('#product-lightbox')?.addEventListener('click', event => {
  if (event.target.tagName === 'DIALOG') event.target.close();
});

const zoomButton = document.querySelector('.lightbox-zoom');
zoomButton?.addEventListener('click', () => {
  const dialog = zoomButton.closest('dialog');
  const zoomed = dialog.classList.toggle('is-zoomed');
  zoomButton.setAttribute('aria-pressed', String(zoomed));
  zoomButton.textContent = zoomed ? 'Fit image' : 'Zoom in';
});

// Use the original form so quantity, variant and browser validation stay consistent.
const mobilePurchaseBar = document.querySelector('.mobile-purchase-bar');
const purchaseForm = document.getElementById('LaunchProductForm');
if (mobilePurchaseBar && purchaseForm) {
  const primaryButton = purchaseForm.querySelector('button[type="submit"]');
  const stickyButton = mobilePurchaseBar.querySelector('button');
  const quantity = purchaseForm.querySelector('[name="quantity"]');
  const mobileViewport = matchMedia('(max-width:800px)');
  const updatePurchaseBar = () => {
    const active = document.activeElement;
    const editing = active?.matches('input,textarea,select,[contenteditable="true"]');
    const reviewForm = document.querySelector('.jdgm-form-wrapper');
    const modalOpen = [...document.querySelectorAll('dialog[open],[role="dialog"][aria-modal="true"]')].some(el => el.getBoundingClientRect().height > 0) || (reviewForm && reviewForm.getBoundingClientRect().height > 0);
    const menuOpen = document.querySelector('.menu-toggle[aria-expanded="true"]');
    mobilePurchaseBar.hidden = !mobileViewport.matches || purchaseForm.getBoundingClientRect().bottom > 0 || Boolean(editing || modalOpen || menuOpen);
    const amount = quantity?.valueAsNumber || 1;
    stickyButton.disabled = primaryButton.disabled;
    stickyButton.textContent = primaryButton.disabled ? 'Sold out' : amount > 1 ? 'Add ' + amount + ' to cart' : 'Add to cart';
  };
  let scheduled = false;
  const schedulePurchaseUpdate = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; updatePurchaseBar(); });
  };
  window.addEventListener('scroll', schedulePurchaseUpdate, {passive:true});
  window.addEventListener('resize', schedulePurchaseUpdate);
  document.addEventListener('focusin', schedulePurchaseUpdate);
  document.addEventListener('focusout', schedulePurchaseUpdate);
  document.addEventListener('click', schedulePurchaseUpdate);
  document.addEventListener('keydown', schedulePurchaseUpdate);
  purchaseForm.addEventListener('input', schedulePurchaseUpdate);
  purchaseForm.addEventListener('change', schedulePurchaseUpdate);
  new MutationObserver(schedulePurchaseUpdate).observe(primaryButton, {attributes:true,attributeFilter:['disabled']});
  document.querySelector('#product-lightbox')?.addEventListener('close', schedulePurchaseUpdate);
  // Review apps can open their dialog asynchronously after the click handler.
  const observedDialogs = new WeakSet();
  const watchDialogs = () => {
    document.querySelectorAll('dialog,[role="dialog"]').forEach(dialog => {
      if (observedDialogs.has(dialog)) return;
      observedDialogs.add(dialog);
      new MutationObserver(schedulePurchaseUpdate).observe(dialog, {attributes:true,attributeFilter:['style','class','open','aria-hidden','aria-modal']});
    });
  };
  watchDialogs();
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('dialog,[role="dialog"]') || node.querySelector('dialog,[role="dialog"]'))))) {
      watchDialogs();
      schedulePurchaseUpdate();
    }
  }).observe(document.body, {childList:true,subtree:true});
  updatePurchaseBar();
}

// Product gallery browsing
{
  const galleryButtons = [...document.querySelectorAll('.product-gallery [data-product-lightbox]')];
  const lightbox = document.querySelector('#product-lightbox');
  const counter = lightbox?.querySelector('[data-gallery-count]');
  let activeIndex = 0;
  const showGalleryImage = index => {
    activeIndex = (index + galleryButtons.length) % galleryButtons.length;
    const source = galleryButtons[activeIndex];
    const image = lightbox.querySelector('img');
    image.src = source.dataset.fullImage;
    image.alt = source.querySelector('img').alt;
    lightbox.querySelector('.lightbox-original').href = source.dataset.fullImage;
    lightbox.classList.remove('is-zoomed');
    const zoom = lightbox.querySelector('.lightbox-zoom');
    zoom.textContent = 'Zoom in';
    zoom.setAttribute('aria-pressed', 'false');
    lightbox.querySelector('.lightbox-viewport').scrollTo(0, 0);
    counter.textContent = (activeIndex + 1) + ' / ' + galleryButtons.length;
  };
  if (lightbox && counter && galleryButtons.length) {
    galleryButtons.forEach((button, index) => button.addEventListener('click', () => showGalleryImage(index)));
    lightbox.querySelector('[data-gallery-previous]').addEventListener('click', () => showGalleryImage(activeIndex - 1));
    lightbox.querySelector('[data-gallery-next]').addEventListener('click', () => showGalleryImage(activeIndex + 1));
    lightbox.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        showGalleryImage(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
  }
}
